import $ from 'jquery';
import EmblaCarousel from 'embla-carousel';
import { setupPrevNextBtns, listenForPrevBtnClick, listenForNextBtnClick, disablePrevNextBtns } from '../utils/PrevNextButtons.js';
import { resizeScroll } from '../core/ScrollService.js';
import { isTouchDevice } from '../utils/WindowUtils.js';
const initTestimonials = () => {
    if (document.querySelectorAll('.pSection--testimonials .testimonials')) {
        document.querySelectorAll('.pSection--testimonials .testimonials').forEach((domElt) => {
            let domEmbla = domElt.querySelector('.embla');
            let domEmblaPrev = domElt.querySelector('.testimonials_nav_prev');
            let domEmblaNext = domElt.querySelector('.testimonials_nav_next');
            let loop = domEmbla.getAttribute('data-loop') && domEmbla.getAttribute('data-loop') === "true";
            let dragFree = domEmbla.getAttribute('data-dragfree') && domEmbla.getAttribute('data-dragfree') === "true";
            let domEmblaOptions = {
                align: 'start',
                loop: loop,
                dragFree: dragFree,
                draggable: isTouchDevice(),
                watchDrag: isTouchDevice(),
                containScroll: 'trimSnaps',
            };
            let domEmblaPlugins = [];

            let embla = EmblaCarousel(domEmbla, domEmblaOptions, domEmblaPlugins);
            setupPrevNextBtns(domEmblaPrev, domEmblaNext, embla);

            embla.on("select", disablePrevNextBtns);
            embla.on("init", disablePrevNextBtns);
            embla.on("init", () => { resizeScroll(); });
        })
    }
};

export { initTestimonials };
